import { hubClear, useCypressSignalRMock } from "cypress-signalr-mock";

const useMockPresence = () => {
  hubClear();
  const hubConnection = useCypressSignalRMock("NotifyEntityPresence");
  return hubConnection;
};

export default useMockPresence;
